import { Link } from "react-router";
import { ChevronRight, Eye, Lock, Shield } from "lucide-react";

type MarketingBottomCtaProps = {
  /** Plain leading segment before the accent span */
  titleBefore: string;
  /** Gradient / teal emphasis segment */
  titleAccent: string;
  description: string;
  /** Show lock / eye / shield icon row (default true) */
  showTrustIcons?: boolean;
};

export function MarketingBottomCta({
  titleBefore,
  titleAccent,
  description,
  showTrustIcons = true,
}: MarketingBottomCtaProps) {
  return (
    <section
      className="py-24 border-t border-slate-800/50"
      style={{ background: "linear-gradient(135deg, var(--color-slate-900) 0%, var(--color-slate-950) 100%)" }}
    >
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {showTrustIcons && (
          <div className="flex items-center justify-center gap-3 mb-6">
            <Lock size={20} className="text-teal-400" />
            <Eye size={20} className="text-emerald-400" />
            <Shield size={20} className="text-teal-400" />
          </div>
        )}
        <h2
          className="text-slate-100 mb-4"
          style={{ fontSize: "2.2rem", fontWeight: 800, letterSpacing: "-0.02em", lineHeight: "1.2" }}
        >
          {titleBefore}
          <span className="text-teal-400">{titleAccent}</span>
        </h2>
        <p className="text-on-dark-muted mb-10 text-base leading-relaxed">{description}</p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/request-demo"
            className="flex items-center justify-center gap-2 bg-teal-600 hover:bg-teal-500 text-white px-8 py-4 rounded-xl transition-all duration-200 hover:shadow-xl hover:shadow-teal-500/30"
            style={{ fontWeight: 600 }}
          >
            <Shield size={18} />
            Schedule Demo
          </Link>
          <Link
            to="/platform"
            className="flex items-center justify-center gap-2 border border-teal-500/30 text-teal-400 hover:bg-teal-500/10 px-8 py-4 rounded-xl transition-all duration-200"
            style={{ fontWeight: 500 }}
          >
            View Platform Architecture
            <ChevronRight size={16} />
          </Link>
        </div>
      </div>
    </section>
  );
}
